<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'no-scroll': isAppPage, 'is-shop-page': isShopPage },
    ]"
  >

    <v-nav-menu
      v-if="iframe.sidebar"
      :navMenuItems="editedNavMenuItems"
      title="Fresh Clinic"
      parent=".layout--main"
      dashboardRoute="/nurse/notice-board"
    />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="navMenuItems"
        />

      </template>

      <template v-else>
        <the-nurse-navbar-vertical
          :navbarColor="navbarColor"
          :sidebar="iframe.sidebar"
          :showUserDropdown="iframe.userDropdown"
          :showCloseCta="iframe.closeCta"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <go-to-v2-banner />
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6  md:block hidden"
              >
                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                  :orderApprovalFlowEnabled="orderApprovalFlowEnabled"
                />
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop && !isShopPage"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="
                    (classesStr) => $emit('setAppClasses', classesStr)
                  "
                />
              </transition>
            </div>
          </div>
        </div>
        <the-footer />
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue';
import navMenuItems from '@/layouts/components/vertical-nav-menu/nurse/NurseNavMenuItems.js';
import nursePermissionMenuItems from '@/layouts/components/vertical-nav-menu/nurse/NursePermissionMenuItems.js';
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue';
import TheNurseNavbarVertical from '@/layouts/components/navbar/nurse/TheNurseNavbarVertical.vue';
import TheFooter from '@/layouts/components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import { isShopRoute } from '@/utils/isShopRoute';
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';
import GoToV2Banner from '@/layouts/components/go-to-v2-banner/GoToV2Banner.vue';
import StaffHelper from '@/mixins/Staff';
import OrganizationHelper from '@/mixins/Organization';
import MenuFilterHelper from '@/mixins/menuFilterMixin';
import { mapActions } from 'vuex';
import { isClinicOrderApprovalFlowEnabled } from '@/globalHelpers/storeHelper';
import { INVENTORY_TEXT } from '../../../views/components/order-center/constants';
import iframeInitializationMixin from '@/mixins/iframeInitializationMixin';

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNurseNavbarVertical,
    VNavMenu,
    GoToV2Banner,
  },
  mixins:[
    StaffHelper,
    OrganizationHelper,
    MenuFilterHelper,
    iframeInitializationMixin,
  ],
  provide() {
    return {
      getRoleRouteName: this.getRoleRouteName,
    };
  },
  data() {
    return {
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems: navMenuItems,
      editedNavMenuItems: [],
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      steps: [
        {
          target: '#btnVNavMenuMinToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based on your preference',
          params: {
            placement: 'left',
          },
        },
        {
          target: '.vs-button.buy-now',
          content: 'Buy this awesomeness at affordable price!',
          params: {
            placement: 'top',
          },
        },
      ],
      organizationId:null,
      permissionMenuItems:nursePermissionMenuItems,
      iframe: {
        sidebar: true,
        navbar: true,
        userDropdown: true,
        footer: true,
      },
      orderApprovalFlowEnabled: null,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
  },
  computed: {
    isShopPage() {
      return isShopRoute(this.$route && this.$route.path);
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      // If sidebar is hidden in iframe mode, use full width
      if (!this.iframe.sidebar) {
        return 'content-area-full';
      }
      
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth == 'default')
          return 'content-area-reduced';
        else if (this.verticalNavMenuWidth == 'reduced')
          return 'content-area-lg';
        else return 'content-area-full';
      }
      else return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark';
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  async mounted() {
    const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');

    try {
      this.orderApprovalFlowEnabled = await isClinicOrderApprovalFlowEnabled(clinicId);
    } catch (error) {
      console.error('Error fetching clinic details:', error);
      this.orderApprovalFlowEnabled = false;
    }
  },

  beforeMount() {
    this.init();
  },

  methods: {
    ...mapActions('admin', ['fetchUserPermission', 'checkPOSEnabledClinicsFromOrg']),

    async init() {
      const clinics = await this.getOrganizationAllowedClinics();

      const organizationId = localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`);
      const {data: hasPOSEnabledClinics} = await this.checkPOSEnabledClinicsFromOrg({organizationId: organizationId});

      const hideMenus = process.env.VUE_APP_REGION === 'US' ? ['Invoice Management', 'Inventory', 'Drugbook'] : [];

      const hiddenMenusByRegion = this.getHiddenMenusByRegion(this.$store);
      hideMenus.push(...hiddenMenusByRegion);

      let permissionMenus = await this.getUserPermissions();
      permissionMenus = permissionMenus.filter((menu) => !hideMenus.includes(menu.name));

      if (!clinics.length) {
        permissionMenus = this.filterMenus(permissionMenus);
      }
      /**
       * Scenario for showing POS in nav.
       * 1. If POS is enabled for a nurse user and
       * a clinic in the organization has POS enabled,
       * POS menu will show in their account.
       * 2. If POS is enabled for a nurse user but
       * there's no POS enabled clinics in the organization,
       * POS will be hidden in the nav.
       * 3. If POS is disabled for a nurse user and
       * a clinic in the organization has POS enabled,
       * POS wil be hidden in the nav.
       */
      const POSPermiIndex = permissionMenus.findIndex((menu) => menu.name === 'POS');
      if (POSPermiIndex !== -1 && !hasPOSEnabledClinics.data) {
        permissionMenus.splice(POSPermiIndex, 1);
      }
      this.editedNavMenuItems = permissionMenus.map((item) => {
        if (this.orderApprovalFlowEnabled && INVENTORY_TEXT[item.name]) {
          return { ...item, i18n: INVENTORY_TEXT[item.name] };
        }

        return item;
      });
    },

    filterNurseLinks() {

    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == 'static')
        this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff');
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == '#fff') this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === 'horizontal' && this.windowWidth >= 1200) ||
        (layoutType === 'vertical' && this.windowWidth < 1200)
      ) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },

  created() {
    this.initializeIframeSettings();
    this.initializeNavbarSettings();
    // Dynamic Watchers for tour
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch(
      '$store.state.windowWidth',
      (val) => {
        if (val < 1200) {
          this.disableThemeTour = true;
          this.dynamicWatchers.windowWidth();
        }
      }
    );

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch(
      '$store.state.verticalNavMenuWidth',
      () => {
        this.disableThemeTour = true;
        this.dynamicWatchers.verticalNavMenuWidth();
      }
    );

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true;
      this.dynamicWatchers.rtl();
    });
  },
  beforeDestroy() {
    Object.keys(this.dynamicWatchers).map((i) => {
      this.dynamicWatchers[i]();
      delete this.dynamicWatchers[i];
    });
  },
};
</script>
